import * as Yup from 'yup'

import { PasswordValidador } from '../../../utils'

export default Yup.object().shape({
    newPassword: Yup.string().required('Nova Senha é obrigatório!')
        .test('Senha', 'A nova senha deve conter pelo menos uma letra maiúscula!', PasswordValidador.hasUpperCase)
        .test('Senha', 'A nova senha deve conter pelo menos uma letra minúscula!', PasswordValidador.hasLowerCase)
        .test('Senha', 'A nova senha deve conter pelo menos um número!', PasswordValidador.hasNumber)
        .test('Senha', 'A nova senha deve conter pelo um caracter especial!', PasswordValidador.hasSpecialChar)
        .test('Senha', 'A nova senha deve conter pelo menos 8 caracteres!', PasswordValidador.hasMinLength),
    confirmPassword: Yup.string().required('Confirmar Nova Senha é obrigatório!')
        .oneOf([Yup.ref('newPassword'), null], 'As senhas não conferem!')
})